module.exports = {
  UNCATEGORIZED: 'uncategorized',
  CATEGORY_DIR: 'categories',
  TAG_DIR: 'tags',
  RSS_FILENAME: 'atom.xml',
};
